/* Progressive enhancement: native details remain usable without this asset. */
(() => {
  if (customElements.get('fizzy-faq')) return;
  class FizzyFAQ extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.states = new Map();
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      requestAnimationFrame(() => {
        if (this.isConnected && !signal.aborted) this.initialize(signal);
      });
    }
    initialize(signal) {
      for (const item of this.querySelectorAll('.fizzy-faq__item')) {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.fizzy-faq__answer-wrap');
        if (!summary || !panel) continue;
        this.states.set(item, { panel, target: item.open, animation: null });
        // Native name grouping is the no-JS fallback. Enhancement animates peers.
        if (typeof panel.animate === 'function') item.removeAttribute('name');
        summary.addEventListener('click', event => {
          // Preserve native activation if animation support is unavailable.
          if (typeof panel.animate !== 'function') return;
          event.preventDefault();
          this.setOpen(item, !this.states.get(item).target);
        }, { signal });
      }
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) {
          for (const [item, state] of this.states) this.finish(item, state);
        }
      }, { signal });
    }
    setOpen(item, open) {
      const state = this.states.get(item);
      if (!state) return;
      if (open && this.dataset.singleOpen === 'true') {
        for (const [other, peer] of this.states) {
          if (other !== item && peer.target) this.setOpen(other, false);
        }
      }
      const { panel } = state;
      const start = item.open ? panel.getBoundingClientRect().height : 0;
      state.animation?.cancel();
      state.target = open;
      if (this.reducedMotion.matches || typeof panel.animate !== 'function') {
        this.finish(item, state);
        return;
      }
      item.open = true;
      panel.style.overflow = 'hidden';
      // Measure native content at its current width; never use fixed heights.
      const end = open ? panel.scrollHeight : 0;
      const animation = panel.animate([{ height: `${start}px` }, { height: `${end}px` }], {
        duration: 220, easing: 'cubic-bezier(.2,0,0,1)', fill: 'both'
      });
      state.animation = animation;
      animation.onfinish = () => {
        if (state.animation === animation) this.finish(item, state);
      };
    }
    finish(item, state) {
      item.open = state.target;
      state.animation?.cancel();
      state.animation = null;
      state.panel.style.removeProperty('overflow');
    }
    disconnectedCallback() {
      this.controller?.abort();
      for (const [item, state] of this.states || []) {
        this.finish(item, state);
        if (this.dataset.singleOpen === 'true') item.setAttribute('name', this.id);
      }
      this.controller = null;
    }
  }
  customElements.define('fizzy-faq', FizzyFAQ);
})();
